import { CL147_SECURITY_AGREEMENT_AREA_COUNTRIES } from 'shared/ncts/common/constants'
import { excludeDeleted } from 'shared/lib/common-util'
import { removePrefix, TRANSIT_OFFICE_CODE_PREFIX } from 'shared/ncts/common/classifier-util'
import { RuleResult } from '../../../../types/DeclarationP5'
import { CustomsOfficeOfTransitDeclared } from '../../common/types'

const C0587Validator = {
  validateTransitExitCustomsOfficeRequirement: ({
    security,
    transitCustomsOffices,
  }: {
    security: string
    transitCustomsOffices: CustomsOfficeOfTransitDeclared[]
  }): RuleResult => {
    if (!['2', '3'].includes(security)) {
      return 'NOT_ALLOWED'
    }

    const isAnyTransitOfficeNotInCountryOfSecurityAgreement = transitCustomsOffices.filter(excludeDeleted)
      .some((transitCustomsOffice) => !CL147_SECURITY_AGREEMENT_AREA_COUNTRIES
        .includes(removePrefix(transitCustomsOffice.referenceNumber, TRANSIT_OFFICE_CODE_PREFIX, 2) ?? ''))

    return isAnyTransitOfficeNotInCountryOfSecurityAgreement ? 'OPTIONAL' : 'NOT_ALLOWED'
  },
} as const

export default C0587Validator
